import Paper from '@mui/material/Paper';
import Input from '@mui/material/Input';

export default function Operation(props) {
  const {
    active,
    highlighted,
    onSetHighlightedOperation,
    onClearHighlightedOperation,
    onSetActiveOperation,
    op,
    children
  } = props;

  const {
    name,
    cmd
  } = op;

  return (<Paper elevation={active ? 2 : 0} 
                 sx={ { margin: 1, padding: 1, paddingLeft: 2, paddingRight: 2, backgroundColor: (highlighted && !active) ? 'primary.light' : (active ?  'white' : '#f2f2f2') }} 
                 onPointerOver={onSetHighlightedOperation} 
                 onPointerOut={onClearHighlightedOperation}>
  <div onClick={onSetActiveOperation}><Input defaultValue={name || cmd} variant="standard" margin="none" disableUnderline={true}/><span style={{ float: "right", fontSize: "smaller", fontStyle: "italic" }}>{cmd}</span><br style={{ clear: "both" }}/></div>
  {active ? 
  <>
  {children}
  </>
  : null}
  </Paper>);
};
